"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveSliderFormMetadataParams = void 0;
/**
 * Resolves alacarte form metadata to the appropriate slider form type.
 * Alacarte forms can lead to either global or contentbased results —
 * the slider edit form should reflect that.
 */
const resolveSliderFormMetadataParams = params => {
  if (params.formType !== "alacarte") return params;
  if (params.contentType && params.formId) {
    return {
      debug: params.debug,
      formType: "contentbased",
      contentType: params.contentType,
      formId: params.formId
    };
  }
  return {
    debug: params.debug,
    formType: "global"
  };
};
exports.resolveSliderFormMetadataParams = resolveSliderFormMetadataParams;